module.exports = __webpack_public_path__ + "static/media/Apple-light.13dc39fc.svg";